<component
  v-if="shouldRenderConfig"
  v-bind:is="getContainerType"
  v-bind:class="getClassName"
>
  <appPageOption
    v-for="(pageOption,key,index) in getActiveProductPageOptions"
    v-bind:key="index"
    v-bind:code="key"
    v-bind:index="index"
    v-bind:propsData="pageOption"
  ></appPageOption>

  <div v-if="shouldRenderConfig" class="matrix_pageOption">
    <button
      type="button"
      class="btn btn-primary"
      v-bind:class="getSummaryActive"
      v-on:click="onClickSelectSummary()"
    >
      <div class="matrix_pageOptionIndex">{{getSummaryIndex}}</div>
      <div class="matrix_pageOptionLabel">{{getSummaryIndex}}. {{$t('Summary')}}</div>
    </button>
  </div>
</component>
